angular
    .module('empower.inbox')
    .controller('inboxController', ['$rootScope', '$scope', '$filter', 'inboxService', 'httpService', 'commonConst', '$timeout', 'claimSumm',
        function ($rootScope, $scope, $filter, inboxService, httpService, commonConst, $timeout, claimSumm) {

            $scope.pageBreadcrumbs = [{ url: '/', title: 'Home' }, { url: null, title: 'Mailbox' }];
            $rootScope.pageName = "Mailbox";

            $scope.rowSelections = commonConst.ROWS_PER_PAGE_ITEMS;
            $scope.listCategories = [{id: 8, name: 'Claim Mail'}, 
                {id: 5, name: 'Investigations'}, 
                {id: 4, name: 'Legal'}, 
                {id: 1, name: 'Medical'}, 
                {id: 3, name: 'Payments'},
                {id: 6, name: 'Rehabilitation'}];
            $scope.listClaims = [];

            $scope.inboxData = {
                esSearchCursor: null,
                isFavoriteOnly: false,
                documentPageNumber: 1,
                documentRowsPerPage: 10,
                isSortDesc: true,
                filterClaims: [],
                filterCategories: []
            };
            $scope.documentList = [];
            $scope.cacheDocumentResponse = [];
            $scope.documentCounts = 0;
            
            $scope.init = function () {
                $scope.queryDocuments();
                $scope.initFilter();
            }

            $scope.initFilter = function () {
                claimSumm.getWorkerClaimNumbers().then(function(response) {
                    $scope.listClaims = response;

                    $timeout(function () {
                        $('#filter-claim').multiselect({
                            dropRight: true,
                            includeSelectAllOption: true,
                            selectedClass: '',
                            buttonText: function (ele, checked) {
                                return '';
                            },
                            templates: {
                                button: '<i class="multiselect dropdown-toggle fa fa-filter" data-toggle="dropdown"></i>'
                            },
                            onChange: function (ele, checked) {
                                $scope.inboxData.filterClaims = $('#filter-claim').val();
                                $scope.refreshListDocument();
                            },
                            onSelectAll: function () {
                                $scope.inboxData.filterClaims = $('#filter-claim').val();
                                $scope.refreshListDocument();
                            },
                            onDeselectAll: function () {
                                $scope.inboxData.filterClaims = null;
                                $scope.refreshListDocument();
                            }
                        });
                    });
                });

                $timeout(function () {
                    $('#filter-category').multiselect({
                        dropRight: true,
                        includeSelectAllOption: true,
                        selectedClass: '',
                        buttonText: function (ele, checked) {
                            return '';
                        },
                        templates: {
                            button: '<i class="multiselect dropdown-toggle fa fa-filter" data-toggle="dropdown"></i>'
                        },
                        onChange: function (ele, checked) {
                            $scope.inboxData.filterCategories = $('#filter-category').val();
                            $scope.refreshListDocument();
                        },
                        onSelectAll: function () {
                            $scope.inboxData.filterCategories = $('#filter-category').val();
                            $scope.refreshListDocument();
                        },
                        onDeselectAll: function () {
                            $scope.inboxData.filterCategories = null;
                            $scope.refreshListDocument();
                        }
                    });
                }, 50);
            }

            $scope.goToPage = function(page) {
                $scope.inboxData.documentPageNumber = page;

                var cacheData = $scope.cacheDocumentResponse[page];
                if (cacheData) {
                    $scope.documentList = cacheData;
                } else {
                    $scope.queryDocuments();
                }
            }


            $scope.queryDocuments = function() {
                inboxService.getWorkerInboxDocuments($scope.inboxData).then(function (response) {
                    $scope.documentList = response.DocumentList;
                    $scope.cacheDocumentResponse[$scope.inboxData.documentPageNumber] = response.DocumentList;

                    $scope.documentCounts = response.DocumentCounts;
                    $scope.inboxData.esSearchCursor = response.EsSearchCursor;
                });
            }

            //View NSI documents
            $scope.viewDocument = function (document, act) {
               inboxService.viewDocument(document, act);
            };

            $scope.updateFavoriteDocument = function(document) {
                inboxService.updateFavoriteDocument(document.Name_, !document.IsFavorite_).then(function(response) {
                    document.IsFavorite_ = !document.IsFavorite_;
                });
            }

            $scope.refreshListDocument = function() {
                $scope.inboxData.documentPageNumber = 1;
                $scope.inboxData.esSearchCursor = null;
                $scope.cacheDocumentResponse = [];

                $scope.queryDocuments();
            }

            $scope.switchFavoriteFilter = function() {
                $scope.inboxData.isFavoriteOnly = !$scope.inboxData.isFavoriteOnly;
                $scope.refreshListDocument();
            }

            $scope.switchSortOrder = function() {
                $scope.inboxData.isSortDesc = !$scope.inboxData.isSortDesc;
                $scope.refreshListDocument();
            }

            $scope.clearDateSearch = function () {
                $scope.inboxData.receivedDateFrom = "";
                $scope.inboxData.receivedDateTo = "";
                $scope.refreshListDocument();
            }

            $scope.applyDateChange = function (dateFrom, dateTo) {
                $scope.inboxData.receivedDateFrom = dateFrom;
                $scope.inboxData.receivedDateTo = dateTo;
                $scope.refreshListDocument();
            }
        }]);
